export const match = {
  confirm: {
    title: "比赛结果",
    confirmed: "已确认",
    disputed: "有争议",
    pending: "待确认",
    confirmAction: "确认比分",
    disputeAction: "有异议",
    disputeReason: "原因（可选）",
    evidenceRequired: "排名赛需要上传球场照片",
    takePhoto: "拍照证明",
    verified: "比赛已确认",
    statusBadge: {
      confirmed: "✓",
      disputed: "✗",
      pending: "⏳",
    },
  },
  evidence: {
    privacy: "照片将在比赛确认后 2 天自动删除",
  },
};
